import Vue from 'vue'
import Vuex from 'vuex'
// import * as firebase from 'firebase'
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database'; 

Vue.use(Vuex)

export default{
    state: { 
      loggedTime:null,
      currentTime: new Date(),
      monthNames:{
        fullName: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        shortName: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      }
        
    },
    //___________________-GETTERS-_________________
    getters: { 
      getLoggedTime(state) {
        return state.loggedTime
      }, 
      getCurrentTime(state){
        return state.currentTime
      },
      getMonthNames(state){
        return state.monthNames
      }
       
       
    },
    //___________________-MUTATIONS-___________________
    mutations:{  
      updateLoggedTime(state, payload) {
        state.loggedTime = payload
      }, 
       
    },
    //____________________-ACTIONS-_____________________
    actions: { 
      //-------------[SETTER]---------------
      setLoading({ commit,state}, payload) { 
        commit('updateLoading', payload)
      },  
      newCode() {
        let time = new Date()
        let ml = time.getMilliseconds()

        let sc = time.getSeconds()
        let mn = time.getMinutes()
        let hr = time.getHours()
        let dy = time.getDate()
        let mt = time.getMonth() + 1

        let code = ''

        //seconds
        if (sc.toString().length === 1) {
          sc = '0' + sc
        }
        //minutes
        if (mn.toString().length === 1) {
          mn = '0' + mn
        }
        //Hours 
        if (hr.toString().length === 1) {
          hr = '0' + hr
        }
        //Day
        if (dy.toString().length === 1) {
          dy = '0' + dy
        }
        //Month
        if (mt.toString().length === 1) {
          mt = '0' + mt
        }
        code = '19' + dy + '' + mt + '' + hr + '' + sc + '' + mn
        return code
      },
    }
}